import React, { useEffect, useState } from 'react';
import Risk from '../../Risk';
import { risksActions } from '../../../../../behavior/risks/index';
import { Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';

type Props = {
  clearChemRiskCalculationDto: () => void;
  values: any;
  chemRiskCalculation: number;
  calculateChemRiskLevel: (arg: any) => void;
  chemRiskLevelResultDto: any;
  initialChemRiskLevelResultDto: any;
  label: string;
  isChemRiskLoading: boolean;
  tooltip: string;
};

const ChemicalRisk = ({
  clearChemRiskCalculationDto,
  values,
  chemRiskCalculation,
  calculateChemRiskLevel,
  chemRiskLevelResultDto,
  initialChemRiskLevelResultDto,
  label,
  isChemRiskLoading,
  tooltip,
}: Props) => {
  const [newDisplayRiskLevel, setNewDisplayRiskLevel] = useState(
    !!initialChemRiskLevelResultDto && !!initialChemRiskLevelResultDto.chemRiskLevel
  );

  const calculateChemicalRisk = () => {
    const { chemicalProduct, substanceAmount, chemicalRiskAttributes } = values;

    const chemRiskLevelRequestDto = {
      state: chemicalProduct.state,
      substanceAmount: substanceAmount,
      volatility: chemicalRiskAttributes.volatility,
      band: chemicalProduct.band,
      dustTendency: chemicalRiskAttributes.dustTendency,
    };
    calculateChemRiskLevel(chemRiskLevelRequestDto);
  };

  const conditionToDisplayChemicalRisk = () => {
    const { chemicalProduct, quantity, chemicalRiskAttributes } = values;

    const hazardBandCondition = chemicalProduct && chemicalProduct.band && chemicalProduct.band.id;

    const liquidGasCondition =
      chemicalProduct &&
      chemicalProduct.state &&
      [1, 2].includes(chemicalProduct.state.id) &&
      chemicalRiskAttributes.boilingPoint &&
      chemicalRiskAttributes.operatingTemperature;

    const solidCondition =
      chemicalProduct &&
      chemicalProduct.state &&
      chemicalProduct.state.id == 3 &&
      chemicalRiskAttributes.dustTendency &&
      chemicalRiskAttributes.dustTendency.id;

    return (
      chemicalRiskAttributes.hasChemRiskCalculation &&
      hazardBandCondition &&
      quantity &&
      (liquidGasCondition || solidCondition)
    );
  };

  const updateChemicalRisk = () => {
    const displayRiskLevel = conditionToDisplayChemicalRisk();
    setNewDisplayRiskLevel(displayRiskLevel);
    if (displayRiskLevel) calculateChemicalRisk();
  };

  useEffect(() => {
    updateChemicalRisk();
  }, [chemRiskCalculation]);

  useEffect(() => {
    const currentChemRiskLevelId = values?.chemicalRiskAttributes?.chemRiskLevel?.chemRiskLevel?.id;

    if (
      chemRiskLevelResultDto?.chemRiskLevel?.id &&
      chemRiskLevelResultDto.chemRiskLevel.id != currentChemRiskLevelId
    )
      values.chemicalRiskAttributes.chemRiskLevel = chemRiskLevelResultDto;
  }, [values]);

  useEffect(() => {
    return () => {
      clearChemRiskCalculationDto();
    };
  }, []);

  const chemRiskLevelResult = chemRiskLevelResultDto || initialChemRiskLevelResultDto;
  return (
    <>
      {isChemRiskLoading && <Loader active size="tiny" />}
      {!isChemRiskLoading && (
        <Risk
          id="chemRisk"
          label={label}
          value={
            chemRiskLevelResult && chemRiskLevelResult.chemRiskLevel
              ? chemRiskLevelResult.chemRiskLevel.id
              : null
          }
          levelColor={
            chemRiskLevelResult && chemRiskLevelResult.chemRiskLevel
              ? chemRiskLevelResult.chemRiskLevel.color
              : null
          }
          display={newDisplayRiskLevel && chemRiskLevelResult}
          tooltip={tooltip}
        />
      )}
    </>
  );
};

ChemicalRisk.defaultProps = {
  label: 'chemical.risk.label.with.value',
  tooltip: 'chemical.risk.tooltip',
};

const mapStateToProps = (state: any) => ({
  chemRiskCalculation: state.risks.chemRiskCalculation,
  chemRiskLevelResultDto: state.risksResult.chemRiskLevelResultDto,
  isChemRiskLoading: state.risksResult.isChemRiskLoading,
});

const mapDispatchToProps = (dispatch: any) => ({
  calculateChemRiskLevel: (chemRiskLevelRequestDto: any) =>
    dispatch(risksActions.calculateChemRiskLevel(chemRiskLevelRequestDto)),
  clearChemRiskCalculationDto: () => dispatch(risksActions.clearChemRiskCalculationDto()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChemicalRisk);
